import React, { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { TypedMemo } from '../modules/common/types';
import { isDemoAccountId } from '../modules/accountSelector/demoAccounts';
import { useAccountId } from '../redux/slices/appInfo/hooks';
import { isDemoScopedQueryKey } from './demoArtistHeader';

/**
 * Resets the cached answers of the demo-scoped procedures (see `demoArtistHeader.ts`) when the
 * demo artist becomes active or stops being active. Their query keys hold no account id, so
 * without the reset the Watchlist of the workspace would show for LaziiBee, and the other way.
 * The next request reads the active account from the store, so it carries the right header.
 */
const DemoArtistQueryResetComponent: React.FC = () => {
  const queryClient = useQueryClient();
  const isDemo = isDemoAccountId(useAccountId());
  const lastIsDemo = useRef(isDemo);

  useEffect(() => {
    if (lastIsDemo.current === isDemo) {
      return;
    }
    lastIsDemo.current = isDemo;
    queryClient.resetQueries({ predicate: (query) => isDemoScopedQueryKey(query.queryKey) }).catch(console.error);
  }, [isDemo, queryClient]);

  return null;
};

export const DemoArtistQueryReset = TypedMemo(DemoArtistQueryResetComponent);
